/** Deployed APIs authenticate with Google. Call sites keep these helpers; they never send a member id. */

export function getDevAuthHeaders(): Record<string, string> {
  return {};
}

export function withDevAuthFetch(baseFetch: typeof fetch = fetch): typeof fetch {
  return (input, init) => baseFetch(input, init);
}
